import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
import Styles from 'src/components/Styles';

function ChangePin() {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none">
      <Path
        d="M9.143 7.5v2.25h5.714V7.5c0-1.554-1.278-2.813-2.857-2.813-1.579 0-2.857 1.26-2.857 2.813zM7.429 9.75V7.5C7.429 5.014 9.475 3 12 3s4.571 2.014 4.571 4.5v2.25h1.143C18.975 9.75 20 10.759 20 12v6.75c0 1.241-1.025 2.25-2.286 2.25H6.286C5.025 21 4 19.991 4 18.75V12c0-1.241 1.025-2.25 2.286-2.25h1.143zM5.714 12v6.75c0 .31.257.563.572.563h11.428a.569.569 0 00.572-.563V12a.569.569 0 00-.572-.563H6.286a.569.569 0 00-.572.563z"
        fill={Styles.Colors.PayNew.black01}
      />
    </Svg>
  );
}

const ChangePinIcon = React.memo(ChangePin);

export default ChangePinIcon;
